module.exports = __webpack_public_path__ + "img/037-nato.4f95d1a7.svg";